<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-3 flex-wrap"
    >
      <a-button type="primary" icon="plus" @click="openModal(null)">
        {{ $t("action.ajouter") }}
      </a-button>
    </div>
    <a-table
      row-key="_id"
      :loading="loading"
      :columns="columns"
      :data-source="rows"
      :pagination="{ pageSize: 10 }"
      :scroll="{ x: 'max-content' }"
    >
      <template slot="uk" slot-scope="text">
        <a-tag :color="text === 'principal' ? 'blue' : 'cyan'">{{
          text === "principal"
            ? $t("comptabilite.unitPrincipal")
            : $t("comptabilite.unitSecondary")
        }}</a-tag>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a-button type="primary" size="small" @click="openModal(record)">
            {{ $t("action.modifier") }}
          </a-button>
          <a-button type="danger" size="small" class="ml-2">
            <a-popconfirm
              :title="$t('requis.supp')"
              @confirm="() => remove(record._id)"
            >
              <a>{{ $t("action.supprimer") }}</a>
            </a-popconfirm>
          </a-button>
        </div>
      </template>
    </a-table>

    <a-modal
      :visible="modalVisible"
      :title="editingId ? $t('action.modifier') : $t('action.ajouter')"
      :confirm-loading="saving"
      :width="560"
      @ok="onModalOk"
      @cancel="closeModal"
      destroy-on-close
      wrap-class-name="parametrage-compact-modal"
    >
      <a-form :form="form" layout="vertical" class="compact-param-form">
        <div class="row">
          <div class="col-md-6">
            <a-form-item :label="$t('etablissement.nom')">
              <a-input
                v-decorator="[
                  'name',
                  { rules: [{ required: true, message: $t('requis.nom') }] },
                ]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item :label="$t('comptabilite.unitKind')">
              <a-select
                v-decorator="[
                  'unitKind',
                  {
                    initialValue: 'principal',
                    rules: [{ required: true }],
                  },
                ]"
              >
                <a-select-option value="principal">{{
                  $t("comptabilite.unitPrincipal")
                }}</a-select-option>
                <a-select-option value="secondary">{{
                  $t("comptabilite.unitSecondary")
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import apiClient from "@/services/axios";

export default {
  name: "UnitesTab",
  beforeMount() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      loading: false,
      rows: [],
      modalVisible: false,
      saving: false,
      editingId: null,
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("etablissement.nom"),
          dataIndex: "name",
          key: "name",
        },
        {
          title: this.$t("comptabilite.unitKind"),
          dataIndex: "unitKind",
          key: "unitKind",
          scopedSlots: { customRender: "uk" },
        },
        {
          title: this.$t("action.actions"),
          key: "action",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await apiClient.get("/compV3/depense/unites");
        this.rows = res.data || [];
      } catch (e) {
        this.$message.error(this.$t("warning.connectionProblem"));
      } finally {
        this.loading = false;
      }
    },
    openModal(record) {
      this.editingId = record ? record._id : null;
      this.modalVisible = true;
      this.$nextTick(() => {
        if (record) {
          this.form.setFieldsValue({
            name: record.name,
            unitKind: record.unitKind || "principal",
          });
        } else {
          this.form.resetFields();
          this.form.setFieldsValue({ unitKind: "principal" });
        }
      });
    },
    closeModal() {
      this.modalVisible = false;
      this.editingId = null;
    },
    onModalOk(e) {
      e.preventDefault();
      this.submit();
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) return;
        this.saving = true;
        const payload = { data: values };
        const req = this.editingId
          ? apiClient.patch(`/compV3/depense/unites/${this.editingId}`, payload)
          : apiClient.put("/compV3/depense/unites", payload);
        req
          .then(() => {
            this.$message.success(this.$t("success.operationEffectue"));
            this.closeModal();
            this.load();
          })
          .catch(() => this.$message.error(this.$t("error.depenseNonMSA")))
          .finally(() => {
            this.saving = false;
          });
      });
    },
    remove(id) {
      apiClient
        .patch(`/compV3/depense/unites/${id}`, {
          data: { status: "inactive" },
        })
        .then(() => {
          this.$message.success(this.$t("success.operationEffectue"));
          this.load();
        })
        .catch(() => this.$message.error(this.$t("error.depenseNonSupp")));
    },
  },
};
</script>
<style scoped>
.compact-param-form >>> .ant-form-item {
  margin-bottom: 10px;
}
</style>
